import { UserManager, WebStorageStateStore } from "oidc-client-ts";
import appSettings from "../AppSettings";

const userManager = new UserManager({
    authority: appSettings.AuthenticationAuthority,
    client_id: "ska8_webdesigner_client",

    redirect_uri: appSettings.AuthenticationRedirectURI, // http://localhost:5173/logincallback
    post_logout_redirect_uri: appSettings.AuthenticationPostLogoutRedirectURI,

    response_type: "code",
    scope: "openid profile SKA8WebAPI",

    automaticSilentRenew: false,
    monitorSession: false,

    userStore: new WebStorageStateStore({ store: window.sessionStorage })
});



export default userManager;
